import Appointment from "../interface/appointment";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import AppointmentOverviewListTile from "./appointmentOverviewListTile";
import { Box } from "@mui/material";
import IPagination from "../interface/iPagination";
import CustomPagination from "../../../components/pagination/customPagination";

import AppointmentOverviewListHead from "./appointmentOverviewListHead";

const AppointmentOverviewList = (): React.JSX.Element => {
  const {
    paginationSettings,
    setPaginationSettings,
    filtertedAppointments,
  }: {
    paginationSettings: IPagination;
    setPaginationSettings: React.Dispatch<React.SetStateAction<IPagination>>;
    filtertedAppointments: Appointment[] | null;
  } = React.useContext(AppointmentOverviewContext);

  return (
    <Box>
      {filtertedAppointments && (
        <React.Fragment>
          <AppointmentOverviewListHead />

          {filtertedAppointments
            .slice(
              (paginationSettings.page - 1) * paginationSettings.rowsPerPage,
              paginationSettings.page * paginationSettings.rowsPerPage
            )
            .map((appointment: Appointment) => (
              <React.Fragment key={appointment.id}>
                <AppointmentOverviewListTile appointment={appointment} />
              </React.Fragment>
            ))}

          <CustomPagination
            items={filtertedAppointments}
            paginationSettings={paginationSettings}
            setPaginationSettings={setPaginationSettings}
          />
        </React.Fragment>
      )}
    </Box>
  );
};

export default AppointmentOverviewList;
